<template>
  <div class="background" ref="card">
    <a-card class="card">
      <div>
        <div style="text-align: center; padding-top: 16px">
          <img
            :src="logoItem.logo_image ? logoItem.logo_image_item.file : logo"
            width="100"
            style="cursor: pointer; margin-top: 16px"
            @click="backIndex"
          />
        </div>
        <div class="title" style="margin-top: 16px">
          <span style="cursor: pointer; font-size: 24px" @click="backIndex">
            {{ logoItem.logo_title && logoItem.logo_title.length > 0 ? logoItem.logo_title : $t("盒木") }}{{ $t("WMS") }}
          </span>
        </div>
        <div style="text-align: center; font-size: 16px; color: #1890ff; margin-top: 8px; margin-bottom: 24px">
          <span>{{ $t("货主查询平台") }}</span> <span style="font-size: 12px">{{ $t("V2.0") }}</span>
        </div>
      </div>
      <router-view />
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/logo.png"),
    };
  },
  computed: {
    logoItem() {
      return this.$store.state.system.logoItem;
    },
  },
  methods: {
    backIndex() {
      window.open("http://www.himool.com", "_self");
    },
  },
};
</script>

<style scoped>
.card {
  width: 520px;
  border-radius: 8px;
  padding-bottom: 64px;
  margin: auto;
}

.background {
  min-height: 100%;
  padding-top: 10vh;
  background: #f0f2f5 url("~@/assets/background.svg") no-repeat 50%;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #1890ff;
  margin-top: 8px;
  font-weight: bold;
}
</style>
